/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { NotificationManagementPage } from '@/pages/NotificationManagement/NotificationManagementPage';

export function NotificationManagementRoute() {
  return <NotificationManagementPage />;
}
